import request from './axios'
import { assembleItemDetailListV2, assembleMenuV2 } from '@/utils/menuV2'
import { MISSING_ROUTE_KIND } from '@/utils/missingRouteReload'

const assembleOptions = {
	freeze: process.env.VUE_APP_DEEP_FREEZE === 'true',
}

export default {
	// 取得菜單 { menuList, remarkList }：後端回正規化結構，於此組成巢狀結構
	getMenu(params) {
		return request
			.post(`/front/store/getMenuV2`, params, {
				missingRouteKind: MISSING_ROUTE_KIND.MENU,
			})
			.then(res => ({
				...res,
				data: assembleMenuV2(res.data, assembleOptions),
			}))
	},
	// 新增訂單
	addOrder(data) {
		return request.post(`/front/order/add`, data, { rejectWithDetail: true })
	},
	// 確認付款
	confirmTransaction(code, params) {
		return request.post(`/callback/${code}/confirm`, params)
	},
	// 取消付款
	cancelTransaction(code, params) {
		return request.post(`/callback/${code}/cancel`, params)
	},
	// 取得取餐資訊
	getOrderInfo(params) {
		return request.get(`/front/order/getInfo`, { params })
	},
	// 取得訂單(依訂單狀態)
	getOrderByStatus(params) {
		return request.get(`/front/order/getListByStatus`, { params })
	},
	// 取得購物車餐點明細陣列（後端查無的餐點不在其中）：後端回正規化結構，於此組成巢狀結構
	getItems(params) {
		return request
			.post(`/front/store/getItemDetailListV2`, params, {
				missingRouteKind: MISSING_ROUTE_KIND.ITEM_DETAIL_LIST,
			})
			.then(res => ({
				...res,
				data: assembleItemDetailListV2(res.data, assembleOptions),
			}))
	},
	// 檢查手機載具是否存在
	checkPhoneCarrier(params) {
		return request.post(`/front/order/checkPhoneCarrier`, params)
	},
}
